import React from 'react'

interface CanvasWindowCloseIconProps {
  size?: number
  className?: string
}

/**
 * „Canvas schließen" — rechtes Segment der Fenster-Umschaltgruppe
 * (Figma `btn Close` 4872:100234, Icon `Icon / PanelRight` mit `Icon / X`).
 *
 * Teilt den abgerundeten Rahmen mit {@link CanvasWindowMaximizeIcon} und
 * {@link CanvasWindowRestoreIcon} — nur der Inhalt darin wechselt, damit die
 * drei Zustände als eine Familie lesbar sind. Monochrom über `currentColor`.
 */
export const CanvasWindowCloseIcon: React.FC<CanvasWindowCloseIconProps> = ({ size = 20, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect
      x="1.335"
      y="2.335"
      width="17.33"
      height="15.33"
      rx="4.665"
      stroke="currentColor"
      strokeWidth="1.33"
    />
    <path
      d="M13 7L7 13M7 7L13 13"
      stroke="currentColor"
      strokeWidth="1.33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
